import "./index.scss";

const SlidingImages = ({ images, imageType, imageAnimation }) => (
  <div className="sliding-img-container">
    <div className="sliding-images">
      {images.map((value, index) => {
        return <img className={`${imageType} ${imageAnimation} image`} src={value.img} alt="image" key={index} />;
      })}
    </div>
  </div>
);
export default SlidingImages;
